
import React, {ReactNode, useEffect, useState} from 'react';
import { useIntl } from 'umi';
import { Checkbox, Justify } from 'tea-component';
import BigNumberChart from '@customComp/BigNumberChart';
import type { IBigNumberChartProps } from '@customComp/BigNumberChart';
import {useTransformBigNumberApiData} from "@customComp/BigNumberChart/hooks";

interface ITrendStatus {
  showStaticTime?: boolean;
}

interface IBigNumberChartWrapProps {
  data: IBigNumberChartProps['data'];
  className?: string;
  right?: ReactNode;
  headerRight?: ReactNode;
  trendStatus?: ITrendStatus;
  isFromAdd?: boolean;
  onStatusChange?: (status: ITrendStatus) => void;
  bigNumbers: any;
  title: ReactNode;
  displayConfig: any;
}

const BigNumberChartWrap: React.FC<IBigNumberChartWrapProps> = (props) => {
  const { bigNumbers, title, displayConfig, className = '', right, headerRight, isFromAdd, trendStatus: oldTrendStatus, onStatusChange } = props;
  const { formatMessage } = useIntl();

  const {type, componentProps, staticTime} = useTransformBigNumberApiData({bigNumbers, displayConfig });
  
  const [trendStatus, setTrendStatus] = useState<ITrendStatus>({
    showStaticTime: isFromAdd,
    ...(oldTrendStatus || {}),
  });

  useEffect(() => {
    setTrendStatus({
      showStaticTime: isFromAdd,
      ...(oldTrendStatus || {}),
    });
  }, [isFromAdd, oldTrendStatus]);

  // 从添加页面进来，默认勾选显示日期，将状态保持到model层
  useEffect(() => {
    if (isFromAdd) {
      onStatusChange?.({
        showStaticTime: isFromAdd,
      });
    }
  }, [isFromAdd]);

  return (<div className={`dbl-trend-wrap`}>
    <Justify
      className='dbl-trend-wrap-header'
      left={<Checkbox
        value={Boolean(trendStatus?.showStaticTime)}
        onChange={(value: boolean) => {
          const next: ITrendStatus = { ...trendStatus, showStaticTime: value };
          setTrendStatus(next);
          onStatusChange?.(next);
        }}>
        {formatMessage({ id: 'dbl_common_show_static_time' })}
      </Checkbox>
      }
      right={headerRight}
    />
    <div className='table-analysis-chart-center'>
      <BigNumberChart
        className={className}
        icon={'plate'}
        type={type}
        componentProps={componentProps}
        title={title}
        subTitle={trendStatus?.showStaticTime ? staticTime : undefined}
        right={right}
      />
    </div>
  </div>);
};

export default BigNumberChartWrap;